import styled from 'styled-components';
import { zIndex } from 'tokens';

export const PanelWrapper = styled.div<{ $overlay?: boolean; $visible?: boolean }>`
	${({ $overlay, $visible }) =>
		$overlay
			? `
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		z-index: ${zIndex.panelOverlay};
		box-shadow: 4px 0 12px rgba(0, 0, 0, 0.1);
		transform: translateX(${$visible ? '0' : '-100%'});
		transition: transform 0.25s cubic-bezier(0.4, 0.0, 0.2, 1);
		pointer-events: ${$visible ? 'auto' : 'none'};
	`
			: `
		grid-area: left-panel;
		z-index: ${zIndex.panel};
	`}
	display: flex;
	flex-direction: column;
`;
